// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eo-background-sheet{background-color:#f7f7f7;border-radius:0 50px;left:50%;margin-left:-50vw;margin-right:-50vw;position:relative;right:50%;width:100vw}.eo-background-sheet.is-decorative{pointer-events:none;z-index:-1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
